import { render, staticRenderFns } from "./time-board-settings.vue?vue&type=template&id=f8c2595a&scoped=true&"
import script from "./time-board-settings.vue?vue&type=script&lang=js&"
export * from "./time-board-settings.vue?vue&type=script&lang=js&"
import style0 from "./time-board-settings.vue?vue&type=style&index=0&id=f8c2595a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c2595a",
  null
  
)

export default component.exports